// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { DealershipService } from '@services/dealership.service';
import { UserService } from '@services/user.service';
import { forkJoin, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DealershipResolver implements Resolve<any> {
    constructor(
        private dealershipService: DealershipService,
        private userService: UserService
    ) {}

    resolve(): Observable<any> {
        const dealerId = this.userService.getDealerId();
        if (dealerId) {
            return this.dealershipService.getDealer$(dealerId);
        }
        // for pddj login for now
        else {
            return of(null);
        }
    }
}
